export const PETITION_STATUS: {[key:string] : string } = { 
    PENDING : 'PENDING',
    COMPLETED : 'COMPLETED'    
  }